import { Link } from 'react-router-dom';

const Footer = () => (
  <footer
    className="py-10 px-4"
    style={{
      background: '#faf8ff',
      borderTop: '1px solid rgba(167,139,250,0.15)',
    }}
  >
    <div className="max-w-lg mx-auto">
      <div className="text-center mb-6">
        <p
          className="text-[#1a1a2e] font-bold text-base"
          style={{ fontFamily: "'M PLUS Rounded 1c', sans-serif" }}
        >
          16タイプ診断
        </p>
        <p
          className="text-[#9ca3af] text-xs mt-1"
          style={{ fontFamily: "'M PLUS Rounded 1c', sans-serif" }}
        >
          あなたの夜職スタイル、16タイプで丸裸にする。
        </p>
      </div>

      <div
        className="h-px w-full mb-6"
        style={{ background: 'rgba(167,139,250,0.15)' }}
      />

      <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2 mb-6">
        <Link
          to="/privacy"
          className="text-sm cursor-pointer hover:text-[#a78bfa] transition-colors whitespace-nowrap"
          style={{
            color: 'rgba(26,26,46,0.5)',
            fontFamily: "'M PLUS Rounded 1c', sans-serif",
            textDecoration: 'none',
          }}
        >
          プライバシーポリシー
        </Link>
        <div className="w-px h-3 bg-[#e5e7eb]" />
        <Link
          to="/tokushoho"
          className="text-sm cursor-pointer hover:text-[#a78bfa] transition-colors whitespace-nowrap"
          style={{
            color: 'rgba(26,26,46,0.5)',
            fontFamily: "'M PLUS Rounded 1c', sans-serif",
            textDecoration: 'none',
          }}
        >
          特定商取引法に基づく表記
        </Link>
        <div className="w-px h-3 bg-[#e5e7eb]" />
        <a
          href="mailto:ggjrevk@icloud.com"
          className="text-sm cursor-pointer hover:text-[#a78bfa] transition-colors whitespace-nowrap"
          style={{
            color: 'rgba(26,26,46,0.5)',
            fontFamily: "'M PLUS Rounded 1c', sans-serif",
            textDecoration: 'none',
          }}
        >
          お問い合わせ
        </a>
      </div>

      <p className="text-center text-[#d1d5db] text-[10px]">
        &copy; 2026 16タイプ診断. All rights reserved.
      </p>
    </div>
  </footer>
);

export default Footer;
